import { useEffect, useState } from "react";
import api from "../../api";

export default function ManualBadgeDialog({ open, onClose, userId }) {
  const [badges, setBadges] = useState([]);
  const [userBadges, setUserBadges] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    Promise.all([
      api.get("/badges?manual=true"),
      api.get(`/badges/user/${userId}`)
    ]).then(([badgeRes, userBadgeRes]) => {
      setBadges(badgeRes.data);
      setUserBadges(userBadgeRes.data);
      setLoading(false);
    });
  }, [open, userId]);

  const isChecked = badgeId => userBadges.some(ub => ub.badgeId === badgeId);

  const handleChange = async (badgeId, checked) => {
    setLoading(true);
    if (checked) {
      await api.post(`/admin/user/${userId}/badge/${badgeId}`);
    } else {
      await api.delete(`/admin/user/${userId}/badge/${badgeId}`);
    }
    // Reload user badges
    const { data } = await api.get(`/badges/user/${userId}`);
    setUserBadges(data);
    setLoading(false);
  };

  if (!open) return null;
  return (
    <div className="modal-bg" style={{position:'fixed',top:0,left:0,right:0,bottom:0,background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div className="modal-content" style={{background:'#222',padding:32,borderRadius:16,minWidth:340,maxWidth:420}}>
        <h2 style={{marginBottom:18}}>Manuelle Abzeichen vergeben</h2>
        {loading ? <div>Lade...</div> : (
          <div>
            {badges.length === 0 ? <div>Keine manuellen Abzeichen vorhanden.</div> : (
              <ul style={{listStyle:'none',padding:0}}>
                {badges.map(badge => (
                  <li key={badge.id} style={{marginBottom:12,display:'flex',alignItems:'center',gap:12}}>
                    <input
                      type="checkbox"
                      checked={isChecked(badge.id)}
                      onChange={e => handleChange(badge.id, e.target.checked)}
                      disabled={loading}
                    />
                    <img src={badge.icon} alt={badge.name} style={{width:32,height:32,borderRadius:8}} />
                    <span style={{fontWeight:600}}>{badge.name}</span>
                  </li>
                ))}
              </ul>
            )}
          </div>
        )}
        <button className="hero-btn-secondary" style={{marginTop:18}} onClick={onClose}>Schließen</button>
      </div>
    </div>
  );
}
